import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu
  const closeMobileMenu = () => {
    setOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? "bg-black/90 backdrop-blur-md py-4 shadow-lg" : "bg-transparent py-6"}`}>
      <div className="container mx-auto px-6 flex justify-between items-center">

        {/* LEFT LOGO */}
        <Link to="/" className="flex items-center">
          <img src="/assets/logo1.jpeg" alt="Hawkins & Brooks Logo" className="h-10 md:h-12 object-contain" />
        </Link>

        {/* HAMBURGER BUTTON (MOBILE) */}
        <div className="md:hidden z-50 cursor-pointer" onClick={() => setOpen(!open)}>
          <div className={`w-6 h-0.5 bg-white mb-1.5 transition-all duration-300 ${open ? "rotate-45 translate-y-2" : ""}`}></div>
          <div className={`w-6 h-0.5 bg-white mb-1.5 transition-all duration-300 ${open ? "opacity-0" : "opacity-100"}`}></div>
          <div className={`w-6 h-0.5 bg-white transition-all duration-300 ${open ? "-rotate-45 -translate-y-2" : ""}`}></div>
        </div>

        {/* NAV LINKS DESKTOP */}
        <div className="hidden md:flex items-center gap-8">
          <NavLink to="/" className={({ isActive }) => `font-display text-sm tracking-widest uppercase hover:text-[#c8a45e] transition-colors ${isActive ? "text-[#c8a45e]" : "text-white"}`}>
            Home
          </NavLink>
          <NavLink to="/properties/residential" className={({ isActive }) => `font-display text-sm tracking-widest uppercase hover:text-[#c8a45e] transition-colors ${isActive ? "text-[#c8a45e]" : "text-white"}`}>
            Properties
          </NavLink>
          <NavLink to="/contact" className="px-6 py-2 bg-[#c8a45e] text-black font-display text-xs font-bold uppercase tracking-wider rounded-none hover:bg-white transition-colors duration-300">
            Contact
          </NavLink>
        </div>

        {/* RIGHT LOGO (DESKTOP ONLY) */}
        <Link to="/" className="hidden md:block">
          <img src="/assets/logo2.jpeg" alt="Secondary Logo" className="h-10 md:h-12 object-contain" />
        </Link>

        {/* MOBILE MENU OVERLAY */}
        <div className={`fixed inset-0 bg-black/95 backdrop-blur-xl z-40 flex flex-col items-center justify-center gap-8 transition-all duration-500 md:hidden ${open ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"}`}>
          <NavLink to="/" onClick={closeMobileMenu} className="font-display text-xl text-white tracking-widest uppercase hover:text-[#c8a45e] transition-colors">
            Home
          </NavLink>
          <NavLink to="/properties/residential" onClick={closeMobileMenu} className="font-display text-xl text-white tracking-widest uppercase hover:text-[#c8a45e] transition-colors">
            Properties
          </NavLink>
          <NavLink to="/contact" onClick={closeMobileMenu} className="px-8 py-3 bg-[#c8a45e] text-black font-display text-sm font-bold uppercase tracking-wider hover:bg-white transition-colors">
            Contact
          </NavLink>
        </div>
      </div>
    </nav>
  );
}
